import React, { useEffect, useState } from "react";
import theme from "../../Utils/theme";
import barIcon from "../../assets/icon/baricon.svg";
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import Fontstyling from "../common/comman";

const LeftMenu = ({ data }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeLeftMenu, setActiveLeftMenu] = useState(null);

  const toggleLeftMenu = (id) => {
    setActiveLeftMenu(activeLeftMenu === id ? null : id);
  };

  useEffect(() => {
    if (location?.pathname.endsWith("/EmpoweRx")) {
      setActiveLeftMenu(1);
    }
  }, [location.pathname]);

  return (
    <>
      <ul className="p-0 gap-1 d-grid">
  {data?.map(({ id, title, pathName, submenu }) => {
    return (
      <li
        className="d-block align-items-start ps-2 py-1"
        key={id}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = theme.PRIMARY_ARCTIC_GRAY;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "";
        }}
      >
        <img src={barIcon} width="24" alt="barIcon" className="me-3" />
        <NavLink
          onClick={() => toggleLeftMenu(id)}
          className="text-wrap"
          to={pathName}
          style={({ isActive }) => ({
            ...Fontstyling.sidebarheading,
            textDecoration: "none",
            lineHeight: "20px",
            color:
            isActive ||
              (location.pathname.endsWith("/HUBExperience") && id === 1) ||
                (location.pathname.endsWith("/utilitydata") && id === 1) ||
                (location.pathname.endsWith("/clientdata") && id === 1) ||
                (location.pathname.endsWith("/report&extract") && id === 1) ||
                (location.pathname.endsWith("/servicerequest") && id === 1) ||
                (location.pathname.endsWith("/clinicalIntake") && id === 1) ||
                // (location.pathname.endsWith("/cedargateadmin") && id === 1) ||
                (location.pathname.endsWith("/planinsightsadmin") && id === 1) ||
                (location.pathname.endsWith("/EmpoweRx") && id === 1)
                ? theme.SECONDARY_NEARLY_BLACK
                : theme.SECONDARY_CHARCOAL_GRAY,
          })}         
        >
          {title}
        </NavLink>
        {submenu && activeLeftMenu === id && (
          <div className="submenu-container">
            <ul className="submenu p-0 gap-1 d-grid">
              {submenu.map(({ smId, title, pathName }) => (
                <li
                  key={smId}
                  className="d-flex align-items-center py-2"
                  style={{ paddingLeft: '3.8rem' }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = theme.PRIMARY_PURE_WHITE;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  <NavLink
                    to={pathName}
                    className="text-wrap"
                    style={({ isActive }) => ({
                      ...Fontstyling.sidebarheading,
                      textDecoration: "none",
                      lineHeight: "20px",
                      color:
                      isActive ||
                          (location.pathname.endsWith("/EmpoweRx") || location.pathname.endsWith("/EmpoweRxRFP")) && id === 1 && smId === 1
                          || (location.pathname.endsWith("RxBlockPricing") && id === 2 && smId === 1)
                          ? theme.SECONDARY_NEARLY_BLACK
                          : theme.SECONDARY_CHARCOAL_GRAY,
                    })}
                  >
                    {title}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        )}
      </li>
    );
  })}
</ul>

      
    </>
  );
  // } else {
  //   return null;
  // }
};

export default LeftMenu;
